
import { StatisticsService } from 'src/app/services/statistics.service';
import { PublicViewTracker, ViewTracker } from './viewtracker';
import { lastValueFrom } from 'rxjs';
import { genUuid } from 'src/app/utils/uuid';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SectionViewTracker extends ViewTracker implements PublicSectionViewTracker {
    constructor(private stats: StatisticsService) {
        super('SectionView');
        
    }
    protected async create(body: any): Promise<any> {
        this.viewId = genUuid();
        // AQUI SE SETEA EL VIEW ID EN EL STATISTICS
        console.log('BODY',body)
        await lastValueFrom(this.stats.sendAnalyticsEvent({
        eventType: 'sectionViewNew',
        properties: {
            sectionViewUuid: this.viewId,
            siteVisitUuid: this.siteVisitUuid,
            sectionId: body.section_id.sectionId,
        }
        }));
    }

    protected ping(): void {
        lastValueFrom(this.stats.sendAnalyticsEvent({
        eventType: 'sectionViewPing',
        properties: { sectionViewUuid: this.viewId, siteVisitUuid: this.stats.siteVisitUuid }
        })).catch();
    }

    protected async startApi(): Promise<void> {
        await lastValueFrom(this.stats.sendAnalyticsEvent({
        eventType: 'sectionViewStart',
        properties: { sectionViewUuid: this.viewId, siteVisitUuid: this.stats.siteVisitUuid }
        }));
    }

    protected async finishApi(): Promise<void> {
        await lastValueFrom(this.stats.sendAnalyticsEvent({
        eventType: 'sectionViewFinish',
        properties: { sectionViewUuid: this.viewId, siteVisitUuid: this.stats.siteVisitUuid }
        }));
    }

    protected async closeApi(): Promise<void> {
        await lastValueFrom(this.stats.sendAnalyticsEvent({
            eventType: 'sectionViewExit',
            properties: { sectionViewUuid: this.viewId, siteVisitUuid: this.stats.siteVisitUuid }
        }));
    }
}

export interface PublicSectionViewTracker extends PublicViewTracker { } 